// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__u0Bul","validationTips":"StatementDescriptor_validationTips__2Q5yZ"};